// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2dm7O","col":"styles_col__3YDQK"};